<template>
  <v-container>
    <v-col cols="12">
      <v-row>
        <v-col lg="4" md="4" sm="12">
          <div class="dashboard-card" style="border-left: solid 2px #428BCA;">
            <div class="dashboard-card-title" style="color: #428BCA">{{$t('dashboard.executions.total')}} ({{currentYear}})</div>
            <div class="dashboard-card-body">{{totalIntegrations}}</div>
          </div>
        </v-col>
        <v-col lg="4" md="4" sm="12">
          <div class="dashboard-card" style="border-left: solid 2px #0C9348;">
            <div class="dashboard-card-title" style="color: #0C9348">{{$t('dashboard.executions.success')}} ({{currentYear}})</div>
            <div class="dashboard-card-body">{{totalSuccess}}</div>
          </div>
        </v-col>
        <v-col lg="4" md="4" sm="12">
          <div class="dashboard-card" style="border-left: solid 2px #C13018;">
            <div class="dashboard-card-title" style="color: #C13018">{{$t('dashboard.executions.error')}} ({{currentYear}})</div>
            <div class="dashboard-card-body">{{totalFails}}</div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="lg5-custom" sm="12" md="" lg="" xl="" >
          <div class="dashboard-card" style="border-left: solid 2px #008080;">
            <div class="dashboard-card-title" style="color: #008080">{{$t('dashboard.amount.api_query')}}</div>
            <div class="dashboard-card-body">{{processAmount.consultaapi}}</div>
          </div>
        </v-col>
        <v-col class="lg5-custom" sm="12" md="" lg="" xl="" >
          <div class="dashboard-card" style="border-left: solid 2px #008080;">
            <div class="dashboard-card-title" style="color: #008080">{{$t('dashboard.amount.job.rest')}}</div>
            <div class="dashboard-card-body">{{processAmount.jobenviadadosrest}}</div>
          </div>
        </v-col>
        <v-col class="lg5-custom" sm="12" md="" lg="" xl="" >
          <div class="dashboard-card" style="border-left: solid 2px #008080;">
            <div class="dashboard-card-title" style="color: #008080">{{$t('dashboard.amount.job.soap')}}</div>
            <div class="dashboard-card-body">{{processAmount.jobenviadadossoap}}</div>
          </div>
        </v-col>
        <v-col class="lg5-custom" sm="12" md="" lg="" xl="" >
          <div class="dashboard-card" style="border-left: solid 2px #008080;">
            <div class="dashboard-card-title" style="color: #008080">{{$t('dashboard.amount.rest_to_soap')}}</div>
            <div class="dashboard-card-body">{{processAmount.resttosoap}}</div>
          </div>
        </v-col>
        <v-col class="lg5-custom" sm="12" md="" lg="" xl="">
          <div class="dashboard-card" style="border-left: solid 2px #008080;">
            <div class="dashboard-card-title" style="color: #008080">{{$t('dashboard.amount.workflow')}}</div>
            <div class="dashboard-card-body">{{processAmount.workflow}}</div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-tabs>
          <v-tab>{{$t('dashboard.view.general')}}</v-tab>
          <v-tab>{{$t('dashboard.view.temporal')}}</v-tab>
          <v-tab-item>
            <v-row>
              <v-col lg="12" md="12" sm="12">
                <v-toolbar-title>{{$t('dashboard.process_situation')}}</v-toolbar-title>
                <bar-chart :options="{responsive: true}" :height="100" :chart-data="generalStatusChartData"></bar-chart>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <br />
            <v-row>
              <!-- Filtros -->
              <v-col lg="3" md="3" sm="12" style="border-right: solid 2px rgba(0,0,0,0.1)">
                <v-toolbar-title>{{$t('dashboard.filters.temporal')}}</v-toolbar-title>
                <v-select
                  :items="yearList"
                  :reload="reloadSwitcher"
                  item-value="value"
                  item-text="label"
                  :label="$t('dashboard.year')"
                  v-model="year"
                  item-color="primary"
                  @change="changeYear"
                />

                <v-select
                  :items="monthList"
                  :reload="reloadSwitcher"
                  item-value="value"
                  item-text="label"
                  :label="$t('dashboard.month')"
                  v-model="month"
                  item-color="primary"
                  @change="changeMonth"
                  :disabled="year == ''"
                />

                <v-select
                    :items="dayList"
                    :reload="reloadSwitcher"
                    item-value="value"
                    item-text="label"
                    :label="$t('dashboard.day')"
                    v-model="day"
                    item-color="primary"
                    @change="changeDay"
                    :disabled="month == ''"
                />

                <v-toolbar-title>{{$t('dashboard.filters.contextual')}}</v-toolbar-title>
                <v-select
                  :items="processList"
                  :reload="reloadSwitcher"
                  item-value="value"
                  item-text="label"
                  :label="$t('dashboard.process')"
                  v-model="process"
                  item-color="primary"
                  @change="changeProcess"
                />

                <v-select
                  :items="integrationList"
                  :reload="reloadSwitcher"
                  item-value="value"
                  item-text="label"
                  :label="$t('dashboard.integration')"
                  v-model="integration"
                  item-color="primary"
                  @change="changeIntegration"
                  :disabled="process == ''"
                />
              </v-col>

              <!-- Gráficos -->
              <v-col lg="9" md="9" sm="12">
                <v-tabs>
                  <v-tab>{{$t('dashboard.situation')}}</v-tab>
                  <v-tab-item>
                    <line-chart :options="{responsive: true}" :height="145" :chart-data="temporalStatusChartDataset"></line-chart>
                  </v-tab-item>

                  <v-tab>{{$t('dashboard.execution_time')}}</v-tab>
                  <v-tab-item>
                    <line-chart :options="{responsive: true}" :height="145" :chart-data="temporalExecutionTimeChartDataset"></line-chart>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-row>
    </v-col>
  </v-container>
</template>

<style scoped>
.dashboard-card {
  border-radius: 4px;
  padding: 20px 25px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);
}
.dashboard-card-title {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
}
.dashboard-card-body {
  font-size: 22px;
}
@media (min-width: 1264px) and (max-width: 1903px) {
    .flex.lg5-custom {
        width: 20%;
        max-width: 20%;
        flex-basis: 20%;
    }
}
</style>

<script>
import Servico from '../../services/DashboardService'
import LineChart from '../chart/LineChart.js'
import BarChart from '../chart/BarChart.js'

export default {
  name: 'dashboard',
  components: {
    LineChart,
    BarChart
  },
  data: () => ({
    process: '',
    integration: '',
    year: '',
    month: '',
    day: '',
    filters: {
      years: [],
      months: [],
      days: [],
      integrations: []
    },
    currentYearCharData: [],
    temporalChartData: [],
    generalChartData: [],
    reloadSwitcher: true,
    processAmount: {
      consultaapi: 0,
      jobenviadadosrest: 0,
      jobenviadadossoap: 0,
      resttosoap: 0,
      workflow: 0
    }
  }),

  computed: {
    blankFilter () {
      return { label: this.$t('keywords.all'), value: '' }
    },
    processList () {
      return [
        this.blankFilter,
        { label: this.$t('keywords.api_query'), value: 'consultaapi' },
        { label: this.$t('keywords.send_data.rest'), value: 'jobenviadadosrest' },
        { label: this.$t('keywords.send_data.soap'), value: 'jobenviadadossoap' },
        { label: this.$t('keywords.rest_to_soap'), value: 'resttosoap' },
        { label: this.$t('keywords.workflow'), value: 'workflow' }
      ]
    },
    yearList () { return [this.blankFilter, ...this.filters.years] },
    monthList () {
      const months = this.filters.months.map(obj => ({ label: this.$t(`dashboard.filters.months.${obj.value}`), value: obj.value }))
      return [this.blankFilter, ...months]
    },
    dayList () { return [this.blankFilter, ...this.filters.days] },
    integrationList () { return [this.blankFilter, ...this.filters.integrations] },
    currentYear () { return this.currentYearCharData.at(-1)?.date ?? '' },
    totalSuccess () { return this.currentYearCharData.at(-1)?.success ?? 0 },
    totalFails () { return this.currentYearCharData.at(-1)?.fail ?? 0 },
    totalIntegrations () { return this.totalFails + this.totalSuccess },
    temporalStatusChartDataset () {
      const labels = this.temporalChartData.map(e => this.formatDate(e.date))
      const datasets = this.chartDatasetOf(
        [
          {
            label: this.$t('dashboard.executions.total'),
            data: this.temporalChartData.map(e => e.success + e.fail)
          }, {
            label: this.$t('dashboard.executions.success'),
            data: this.temporalChartData.map(e => e.success)
          }, {
            label: this.$t('dashboard.executions.error'),
            data: this.temporalChartData.map(e => e.fail)
          }
        ],
        true
      )
      return { labels, datasets }
    },
    temporalExecutionTimeChartDataset () {
      const labels = this.temporalChartData.map(e => this.formatDate(e.date))
      const datasets = this.chartDatasetOf(
        [
          {
            label: this.$t('dashboard.api'),
            data: this.temporalChartData.map(e => e.timeApi)
          }, {
            label: this.$t('dashboard.scheduled'),
            data: this.temporalChartData.map(e => e.timeJob)
          }
        ]
      )
      return { labels, datasets }
    },
    generalStatusChartData () {
      const labels = this.generalChartData.map(e => this.formatDate(e.date))
      const datasets = [
        {
          label: this.$t('dashboard.executions.success'),
          backgroundColor: '#0C9348',
          data: this.generalChartData.map(e => e.success)
        },
        {
          label: this.$t('dashboard.executions.error'),
          backgroundColor: '#C13018',
          data: this.generalChartData.map(e => e.fail)
        }
      ]
      return { labels, datasets }
    }
  },

  mounted () {
    this.loadGeneralData()
    this.loadTemporalCharts()
  },
  methods: {
    async loadGeneralData () {
      try {
        const temporalResponse = await Servico.getTemporalStatusChartData()
        this.currentYearCharData = temporalResponse.data.data

        const generalResponse = await Servico.getGeneralStatusChartData(this.currentYear)
        this.processAmount = { ...this.processAmount, ...generalResponse.data['register-amount'] }
        this.generalChartData = generalResponse.data.data
      } catch (error) {
        this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`)
      }
    },
    async loadTemporalCharts () {
      try {
        const { data } = await Servico.getTemporalStatusChartData(this.year, this.month, this.day, this.process, this.integration)
        this.temporalChartData = data.data
        this.changeFilters(data.filters)
      } catch (error) {
        this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`)
      }
    },
    changeFilters (filters) {
      if (!filters) return
      if (filters.days) this.filters.days = filters.days.map(obj => ({ label: obj.key, value: obj.value }))
      if (filters.integrations) this.filters.integrations = filters.integrations
      if (filters.months) this.filters.months = filters.months
      if (filters.years) this.filters.years = filters.years
    },
    changeYear () {
      this.month = ''
      this.filters.months = []
      this.loadTemporalCharts()
    },
    changeMonth () {
      this.day = ''
      this.filters.days = []
      this.loadTemporalCharts()
    },
    changeDay () {
      this.loadTemporalCharts()
    },
    changeProcess () {
      this.integration = ''
      this.filters.integrations = []
      this.loadTemporalCharts()
    },
    changeIntegration () {
      this.loadTemporalCharts()
    },
    chartDatasetOf (datasets, critical = false) {
      const defaultColors = ['#ADE500', '#67ACBC', '#008080', '#063951', '#400753', '#50201F', '#EB5B5C', '#F5A319']
      const criticalColors = ['#428BCA', '#0C9348', '#C13018', '#F8931F', '#FCBF10', '#50201F', '#EB5B5C', '#F5A319']
      const colors = critical ? criticalColors : defaultColors

      for (let i = 0; i < datasets.length; i++) {
        const index = i % colors.length
        datasets[i].borderColor = colors[index]
        datasets[i].pointBorderColor = 'white'
        datasets[i].pointBackgroundColor = colors[index]
        datasets[i].pointRadius = 4
        datasets[i].fill = false
      }

      return datasets
    },
    formatDate (date) {
      const match = /(\d\d)-\w+/.exec(date)
      if (match) return this.$t(`dashboard.filters.months.${match[1]}`)
      return date
    }
  }
}
</script>
